<template>
  <v-row class="pt-5" v-if="doc">
     
    <v-col cols="4">
        <v-card
        class="mx-auto card--fade"
        light
      >
        <v-img class="white--text align-end" :src="archetype.src"> </v-img>
        <v-card-title>{{ archetype.name }}</v-card-title>
      </v-card>
    </v-col>
    <v-col cols="8">
      <h2 class="headline">{{type.title}}</h2>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsFunctionalityUser",
  data() {
    return {
      doc: null,
      cols: 4,
    };
  },
  props: {
    uid: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise(val);
      }
    },
  },
  mounted() {
    this.getExercise(this.uid);
  },
  computed: {
      ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    archetype() {
      return this.doc ? this.doc.doc.archetype[0] : null;
    },
    type() {
      return this.doc ? this.doc.doc.type : null;
    }
  },
  methods: {
    getExercise(id) {
      this.doc = null;
      console.log(id)
      // get a ref to the exercise and listen to changes
      let ref = fb.archetypesExCollection
        .where("uid", "==", id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.doc = items[0];
          }
        })
        .catch(function() {});
    }
  },
};
</script>
